export enum ReportStatus {
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  FINISHED = 'FINISHED',
  FAILED = 'FAILED',
  RE_RUN = 'RE_RUN'
}

export enum ReportsTypes {
  AG_OPERATION = 'AG_OPERATION',
  APPLICATION_STATISTICS = 'APPLICATION_STATISTICS',
  BLOCKED_FIELDS = 'BLOCKED_FIELDS',
  CONTROL_STRATEGIES = 'CONTROL_STRATEGIES',
  DISEASE_RISK = 'DISEASE_RISK',
  DISEASE_RISK_NOTES = 'DISEASE_RISK_NOTES',
  MONITORING = 'MONITORING',
  MONITORING_CONSOLIDATED = 'MONITORING_CONSOLIDATED',
  MONITORING_DETAILED = 'MONITORING_DETAILED',
  NEMA_SAMPLING_POINTS = 'NEMA_SAMPLING_POINTS',
  NEMA_INSIGHTS = 'NEMA_INSIGHTS',
  NOTES = 'NOTES',
  PROPERTY = 'property',
  RAIN_GAUGE_REPORT = 'RAIN_GAUGE',
  SAMPLE = 'SAMPLE_POINT',
  SAMPLING = 'SAMPLING',
  SAMPLING_IMPORT = 'SAMPLING_IMPORT',
  SCOUTING = 'scouting',
  SEASON_REPORT = 'SEASON_REPORT',
  SPRAY = 'spray',
  TRACKING = 'tracking',
  TRAP = 'TRAP',
  VISIT = 'VISIT',
  WAREHOUSE_INVENTORY = 'INVENTORY',
  SUBSCRIPTION_MANAGEMENT = 'SUBSCRIPTION_MANAGEMENT',
  TREND_REPORT = 'TREND_REPORT',
  ONLINE_REPORT = 'ONLINE_REPORT',
  AI_INSIGHTS_SEASON_REPORT = 'AI_INSIGHTS_SEASON_REPORT'
}

export enum TrapInstallationStatus {
  MONITORING = 'MONITORING',
  INSTALL = 'INSTALL',
  RENEWED = 'RENEWED',
  EXPIRED = 'EXPIRED',
  UNINSTALLED = 'UNINSTALLED'
}
